import { AloftArea, AloftPrice } from '@aloft/toolkit-shared';

import { Td } from '../../../../components/PdfExportV2/Td/Td.tsx';
import { Text } from '../../../../components/PdfExportV2/Text/Text.tsx';
import { Tr } from '../../../../components/PdfExportV2/Tr/Tr.tsx';
import { getCostString } from '../../../costApproach/utils/getCostString.ts';
import { getPricePerSquareFoot } from '../../../costApproach/utils/getPricePerSquareFoot.ts';
import { BORDER } from '../consts.ts';
import { textStyleOverrides } from './consts.ts';
import { makeColSpan } from './utils/makeColSpan.ts';

export const ExportCostApproachCostRow = ({
  label,
  area,
  cost,
}: {
  label: string;
  area: AloftArea | undefined;
  cost: AloftPrice | undefined;
}) => {
  const price = getPricePerSquareFoot(area, cost);

  return (
    <Tr>
      <Td
        style={{
          width: makeColSpan(0, 1),
          borderLeft: BORDER,
        }}
      >
        <Text variant="body1" {...textStyleOverrides}>
          {label}
        </Text>
      </Td>
      <Td
        style={{
          width: makeColSpan(1, 3),
        }}
      >
        <Text variant="body1" {...textStyleOverrides}>
          {area ? `${area.toSqFt().toString()}` : ''}
        </Text>
      </Td>
      <Td
        style={{
          width: makeColSpan(4, 3),
        }}
      >
        <Text variant="body1" {...textStyleOverrides}>
          {price ? `${price.toString()} per sf` : ''}
        </Text>
      </Td>
      <Td
        style={{
          width: makeColSpan(7, 1),
          textAlign: 'right',
        }}
      >
        <Text variant="body1" {...textStyleOverrides}>
          {getCostString(cost) ?? ''}
        </Text>
      </Td>
    </Tr>
  );
};
